import React from "react";
import { Link } from "react-router-dom";
import Heading from "../../common/Heading";
import Seo from "../../components/Seo";
import { CATEGORY_PAGES } from "../../seo/categories";

/**
 * Unknown URLs used to be rewritten to the homepage and answered with HTTP 200,
 * so this page was effectively unreachable and never needed to do any work.
 * Dropping that rewrite means Firebase now serves a real 404 and people
 * genuinely land here — usually from a stale link, a shared URL for a festival
 * product that has gone out of season, or a typo. So it has to offer a way on
 * rather than just naming the problem.
 */
export default function NotFoundPage() {
  return (
    <>
      <Seo
        title="Page Not Found | NT Sticks"
        description="That page doesn't exist. Browse our dhoop sticks, incense, cones and havan cups instead."
        noindex
      />
      <Heading title="Home" subtitle="Page Not Found" />
      <div className="container text-center" style={{ padding: "2rem 0 3.5rem" }}>
        <h1>We couldn't find that page</h1>
        <p style={{ maxWidth: "34rem", margin: "1rem auto 2rem" }}>
          The link may be out of date, or it might point to a festival product
          that's no longer in season. Everything we make is still in the shop.
        </p>

        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: ".75rem",
            justifyContent: "center",
            marginBottom: "2.5rem",
          }}
        >
          <Link className="btn btn-primary" to="/shop">
            Browse all fragrances
          </Link>
          <Link className="btn btn-outline-secondary" to="/wholesale">
            Wholesale enquiry
          </Link>
        </div>

        <p style={{ marginBottom: ".75rem" }}>Or jump straight to a range:</p>
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: ".5rem 1.25rem",
            justifyContent: "center",
          }}
        >
          {CATEGORY_PAGES.map((cat) => (
            <Link key={cat.path} to={cat.path}>
              {cat.name}
            </Link>
          ))}
        </div>
      </div>
    </>
  );
}
